// @flow

import React from 'react';
import styled from 'styled-components';
import { EmptyPage, Spinner } from '@e4/ui';
import translate from '@e4/intl/translate.macro';

const Content = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const LoadingPage = ({ pastDelay }: { pastDelay: boolean }) => {
  return (
    <EmptyPage title={translate('app.loading')}>
      <Content>{pastDelay && <Spinner />}</Content>
    </EmptyPage>
  );
};
LoadingPage.displayName = 'LoadingPage';

export default LoadingPage;
